import { SaveDialogProps } from "designSystem/components/dialog/SaveDialog";
import declare from "dojo/_base/declare";

const InformationMessageAggregateController = declare(null, {
	/** message to display on top of the Dialog main content */

	messageRes: null,
	/**
     * @override
     * Add message to the dialog
     * @param {ViewWidget} [widget]
     * @return {Partial<SaveDialogProps>}
     */
	getReactSaveDialogProps(widget): Partial<SaveDialogProps>{
		const originalProps = this.inherited<Partial<SaveDialogProps>>(arguments);

		if (!this.messageRes) {
			return originalProps;
		} else {
			return {
				...originalProps,
				customMessageProps: {
					titleRes: this.messageRes,
					variant: "info",
				},
			};
		}
	},
});

export = InformationMessageAggregateController;